/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : ErrorNotification.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Error notification component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date         :
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { Notification } from "@scuf/common";
import { IErrorState } from "models/ui";
import { useDispatch } from "react-redux";
import { setErrorNotification } from "stores/UIStore";
import "./ErrorNotification.scss";

interface IErrorNotificationProps {
  error: IErrorState | null;
}

export const ErrorNotification: FC<IErrorNotificationProps> = ({ error }) => {
  const dispatch = useDispatch();

  return error ? (
    <Notification
      data-testid="error-notification-test"
      hasIcon={true}
      className="common-api-error"
      severity="critical"
      title={error?.errorDescription.toUpperCase()}
      onCloseClick={() => dispatch(setErrorNotification(null))}
    >
      <div>
        There was an error in processing your request. Please refresh and try
        again. If the issue still persists, please contact{" "}
        <a href="mailto:dsa@honeywellaerospace.com">dsa@honeywellaerospace.com</a> for assistance.
      </div>
      <div>
        Email: <a href="mailto:dsa@honeywellaerospace.com">dsa@honeywellaerospace.com</a> for any help
      </div>
    </Notification>
  ) : null;
};
